<template>
  <span @click="toggleCaret">
    <font-awesome-icon v-if="showCaret" :icon="icon" class="mr-md-2 mr-2" ></font-awesome-icon>
    <slot></slot>
  </span>
</template>
<script>

const CARET_RIGHT = 'caret-right';
const CARET_DOWN = 'caret-down';
export default {
  name: 'togglable-caret-header',
  props: {
    showCaret: true
  },
  data() {
    return {
      open : false
    }
  },
  computed: {
    icon() {
      return this.open ? CARET_DOWN : CARET_RIGHT;
    }
  },
  created() {
    if(this.$attrs.open) {
      this.open = Boolean(this.$attrs.open);
    }
  },
  methods: {
    toggleCaret() {
        this.open = !this.open;
    }
  }
}
</script>
<style scoped lang="scss">
</style>